import React from "react";
import moment from "moment-timezone";
import { useDrag } from "react-dnd";
import { get } from "lodash";

import { fetchPatch } from "../../../api/fetch";

import Box from "@material-ui/core/Box";

import { dragTypes } from "../../../constants/dragTypes";

import { getOccurrenceDeparture } from "../../../utils/scheduler";

const SchedulerOccurrenceDraggable = (props) => {
  const { group, refresh } = props;

  const dragEnd = async (item, monitor) => {
    const dropResult = monitor.getDropResult();
    if (item && dropResult) {
      const occurrence = get(item, ["group"]);

      const slot = get(dropResult, ["slot"]);
      const date = get(dropResult, ["date"]);

      const timeSlotStart = moment(date)
        .add(get(slot, ["start", "hours"]), "h")
        .add(get(slot, ["start", "minutes"]), "m")
        .valueOf();
      const timeSlotEnd = moment(date)
        .add(get(slot, ["end", "hours"]), "h")
        .add(get(slot, ["end", "minutes"]), "m")
        .valueOf();

      let shouldRefresh = false;

      if (get(occurrence, ["when"]).valueOf() !== timeSlotStart) {
        try {
          await fetchPatch(
            `schedules/${get(occurrence, ["schedule", "id"])}/occurrences/${get(
              occurrence,
              ["id"]
            )}`,
            {
              when: timeSlotStart,
            }
          );
          shouldRefresh = true;
        } catch (e) {
          console.log(e);
        }
      }

      const timeSlotLength = (timeSlotEnd - timeSlotStart) / 60000;
      if (
        get(getOccurrenceDeparture(occurrence), ["relative_time_min"]) !==
        timeSlotLength
      ) {
        try {
          await fetchPatch(
            `schedules/${get(occurrence, ["schedule", "id"])}/occurrences/${get(
              occurrence,
              ["id"]
            )}/events/${get(getOccurrenceDeparture(occurrence), ["id"])}`,
            {
              relative_time_minutes: timeSlotLength,
            }
          );
          shouldRefresh = true;
        } catch (e) {
          console.log(e);
        }
      }
      if (refresh && shouldRefresh) refresh();
    }
  };

  const [{ isDragging }, drag] = useDrag(() => ({
    type: dragTypes.OCCURRENCE,
    item: { group: group },
    end: dragEnd,
    collect: (monitor) => ({
      isDragging: !!monitor.isDragging(),
    }),
  }));

  return (
    <Box
      ref={drag}
      style={{
        opacity: isDragging ? 0.5 : 1,
      }}
    >
      {props.children}
    </Box>
  );
};

export default SchedulerOccurrenceDraggable;
